/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Signal sent to the container on shutdown.
 *
 * @remarks
 */
export const EnvironmentShutdownSignal = {
  Sigterm: "SIGTERM",
  Sigint: "SIGINT",
  Sigquit: "SIGQUIT",
  Sigkill: "SIGKILL",
} as const;
/**
 * Signal sent to the container on shutdown.
 *
 * @remarks
 */
export type EnvironmentShutdownSignal = ClosedEnum<
  typeof EnvironmentShutdownSignal
>;

/** @internal */
export const EnvironmentShutdownSignal$inboundSchema: z.ZodNativeEnum<
  typeof EnvironmentShutdownSignal
> = z.nativeEnum(EnvironmentShutdownSignal);
/** @internal */
export const EnvironmentShutdownSignal$outboundSchema: z.ZodNativeEnum<
  typeof EnvironmentShutdownSignal
> = EnvironmentShutdownSignal$inboundSchema;
